import useUploadListener from "./useUploadListener";
import { useRef, useEffect, useState } from 'react';
import { useStore, useDispatch } from 'react-redux';
import onUploadFilesSelected from './onUploadFilesSelected';
import G from './Getters';
import A from './ActionCreators';
import DropTargetBox from './DropTargetBox';

export const getFilesFromEvent = e => {
  let files;
  if( e.dataTransfer && e.dataTransfer.files ){
    files = Array.from(e.dataTransfer.files);
  }else{
    files = Array.from(e.target.files);
  }
  return files;
}

const dropTargetBoxStyle = {
  position:'absolute',
  top:'2.5%',
  left:'2.5%',
  width:'95%',
  height:'95%',
}


export default function AppImageUploader({onDrop}){

  const store = useStore();
  const dispatch = useDispatch();
  const [isDraggingFile,setIsDraggingFile]=useState(false);
  const containerRef = useRef(null);
  const fileUploader = useRef(null);
  useUploadListener({setIsDraggingFile});
  

  let onChange = function(e){
    e.stopPropagation();
    let files = getFilesFromEvent(e);
    onUploadFilesSelected(files,dispatch); 
    setIsDraggingFile(false);
  }

  /*
  if( process.env.NODE_ENV === 'development' ){

    let oldOnChange = onChange;

    onChange = function(e){
      let state = store.getState();

      if( !G.isLoggedIn(state) ){

        let loginDevBeforeUploads = window.confirm("You are not logged in. Do you want to auto-login-dev before proceeding?");


        if( loginDevBeforeUploads ){

          dispatch(A.tryLogin({
            email:'sciugo.testing@sciugo.com',
            password:'jonahlibrach'
          })).then(() => {
            alert("HELLO?");
            console.log(e);
            oldOnChange(e);
          })

        }else{
          oldOnChange(e);
        }
      }else{

        oldOnChange(e);

      }

    }

    
  }
  */

  useEffect(() => {},[containerRef])


  return isDraggingFile && (
    <>
    <div style={{
      position:'fixed',
      width:'100%',
      height:'100%',
      top:0,
      left:0,
      background:'#111',
      opacity:0.9,
      zIndex:99999999999
    }}>

      <DropTargetBox 
        onDrop={e => {onChange(e); onDrop()}}
        mouseEnteredColor={"#111"}
        style={dropTargetBoxStyle}>
        <div style={{
          marginTop:'25%',
          transform:'translate(0,-50%)',
          fontSize:64,color:'white'
        }}>
          Drop Images (PNG,JPEG,TIFF) To Upload
        </div>
      </DropTargetBox>


    </div>

      <input 
        custom-tag={"image-uploader"} 
        onChange={onChange} 
        ref={fileUploader} 
        style={{display:'none'}} 
        type="file" 
        class="hidden"
      />

    </>

  )



}
